import React from 'react';
// import { useFormikContext } from 'formik';
// import history from 'browserHistory';
import VisitiorCard from 'modules/kiosk//components/VisitorCard';
import Loader from 'modules/kiosk/components/Loader';
// import styles from './AddingVisitor.module.scss';

type Props = {
  handleChange: any;
  onOpenKeyboard: any;
  loading: boolean;
  onDeleteField: any;
};

const AddingVisitor: React.FC<Props> = ({ handleChange, onOpenKeyboard, loading, onDeleteField }) => (
  <>
    {loading ? (
      <Loader />
    ) : (
      <div className="bck">
        <VisitiorCard
          type="driver"
          handleChange={handleChange}
          onClick={onOpenKeyboard}
          onDeleteField={() => onDeleteField('driver')}
        />
      </div>
    )}
  </>
);

export default AddingVisitor;
